
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Search, X } from "lucide-react";

interface DriversFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortBy: string;
  onSortChange: (value: string) => void;
  onClearFilters: () => void;
}

export function DriversFilters({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
  onClearFilters
}: DriversFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4 p-4 bg-white border rounded-lg shadow-sm">
      <div className="flex-1 min-w-64">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <Input
            placeholder="البحث بالاسم..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10"
          />
        </div>
      </div>
      
      <div className="min-w-48">
        <Select value={sortBy} onValueChange={onSortChange}>
          <SelectTrigger>
            <SelectValue placeholder="ترتيب حسب" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="created_at_desc">الأحدث أولاً</SelectItem>
            <SelectItem value="name_ar_asc">الاسم (أ-ي)</SelectItem>
            <SelectItem value="name_ar_desc">الاسم (ي-أ)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <Button
        variant="outline"
        onClick={onClearFilters}
        className="flex items-center gap-2"
      >
        <X className="w-4 h-4" />
        مسح الفلاتر
      </Button>
    </div>
  );
}
